import { createContext, useContext, type FunctionComponent, type PropsWithChildren } from 'react'

/**
 * In-page mode for the content-pages tools: `true` on the partner-scoped (multi-warehouse) route
 * subtree, `false` on the legacy retailer-scoped subtree.
 *
 * This is intentionally route-driven, not access-control-driven. The same dashboard/builder
 * components mount under both subtrees, and who can reach each subtree is already decided by the
 * route/nav gates (`contentPagesMultiWarehouseAccessControl` and its complement). Re-deriving the
 * mode from those gates in-page breaks for internal accounts: they bypass `minICPlatformVersion`,
 * so the multi-warehouse gate is satisfied everywhere and the legacy page renders the new UI.
 * Deriving from the route keeps each subtree in its own mode for every user (internal or external,
 * with or without a version override).
 */
const ContentPagesMultiWarehouseContext = createContext(false)

export const ContentPagesMultiWarehouseProvider: FunctionComponent<PropsWithChildren<unknown>> = ({
  children,
}) => (
  <ContentPagesMultiWarehouseContext.Provider value>
    {children}
  </ContentPagesMultiWarehouseContext.Provider>
)

export const useContentPagesMultiWarehouse = (): boolean =>
  useContext(ContentPagesMultiWarehouseContext)
